import {
    Box, Button, Icon,
    Paper, Tooltip, Typography, useTheme,   
    FormControl,
    Select,
    MenuItem,    
    InputLabel,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ptBR } from '@mui/x-data-grid/locales';
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { FerramentasDaListagem } from "../../shered/components";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Loading } from "../../shered/components/loading/Loading";
import { FranquiaService, ILstDrop } from "../../shered/services/api/franquia/FranquiaService";
import dayjs from "dayjs";
import { DisputaService, IDadosCalendario } from "../../shered/services/api/disputa/DisputaService";

export const ListagemDeCalendarioFranquia: React.FC    = () => {

    const theme = useTheme();
    const { themeName } = useAppThemeContext();  
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    const user = CookieService.get("access_user");
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../../semimagemescudo.png");
    const [showImagemLiga, setShowImagemLiga] = useState<any>("../../../semimagemescudo.png");
    const [semImagem, setSemImagem] = useState<any>("../../../semimagem.png");
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    const [dadosCalendarioRow, setDadosCalendarioRow] = useState<IDadosCalendario[]>([]);
    const [temporadaFiltro, setTemporadaFiltro] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [minhaFranquia, setMinhaFranquia] = useState(0);
    const [lstFranquias, setLstFranquias] = useState<ILstDrop[]>([]);

    const [searchParams, SetSearchParams] = useSearchParams();
    const [franquiaFiltro, setFranquiaFiltro] = useState(0);
    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    useEffect(() => {
        setIsLoading(true);
        setRemoveLoading(false);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar("/dashboard");
            return;
        } else {
            const fetchData = async () => {
                await UtilidadeService.getTemporadasLiga(Number(codigoLiga))
                    .then((result) => {
                        const tmps = result.data.dado;
                        let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                        setLstTemporadas(lstTemporadasAux);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModalMensagem({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            return;
                        }

                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;

                    });

                await FranquiaService.getByIdLiga(Number(codigoLiga))
                    .then((result) => {
                        const franquias = result.dado;
                        const lstF = result.dado;
                        let minha = lstF.find(f => f.codigo_Usuario === user.codUsuario);
                       
                        setMinhaFranquia(minha != undefined ? minha?.codigo : 0)
                        let lstFranquiasAux = result.dado.map((f, i) => ({ codigo: f.codigo, label: f.nome === null ? `Franquia ${i + 1} ` : f.nome, descricao: f.caminho_Logo }));
                        setLstFranquias(lstFranquiasAux);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    });

                await LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                    .then((result) => {
                        const liga = result.dado;
                        setDadosLiga(liga);
                        
                        if (liga.caminho_Logo !== null) {
                            setShowImagemLiga(liga.caminho_Logo);
                        }
                        setTemporadaFiltro(liga.codigo_Temporada);
                        CarregarCalendarioFranquia(liga.codigo, liga.codigo_Temporada, liga.codigo_Franquia);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModalMensagem({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }

                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            setRedirecionar(`/usuario/liga/${codLocal}`);
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    });

                setIsLoading(false);
                setRemoveLoading(true);
            }
            fetchData();
        }
    }, []);


    const CarregarCalendarioFranquia = async (codigoLiga: number, codigoTemporada: number, codigoFranquia: number) => {
        setFranquiaFiltro(codigoFranquia);       
        DisputaService.getCalendarioFranquia(codigoLiga, codigoTemporada, Number(codigoFranquia))
            .then((result) => {
                const lstDados = result.dado;
                setDadosCalendarioRow(lstDados);
            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }

                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });

                //setRedirecionar(`/usuario/liga/${codLocal}`);
                return;
            });
    }


    const handleSelectedTemporada = async (e: { target: { name: string; value: any; }; }) => {
        setTemporadaFiltro(e.target.value);
        setDadosCalendarioRow([]);
    }

    const handleSelectedFranquia = async (e: { target: { name: string; value: any; }; }) => {
        setFranquiaFiltro(Number(e.target.value));
        setTemporadaFiltro(temporadaFiltro);        
        setDadosCalendarioRow([]);
        CarregarCalendarioFranquia(Number(codigoLiga), Number(temporadaFiltro), Number(e.target.value))
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    };

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }
    }

    const columnsGeral: GridColDef[] = [
        {
            field: 'codigo',
            headerName: '',
            flex: 1,
            minWidth: 58,
            maxWidth: 58,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'rodada',
            headerName: UtilidadeService.isMobile() ? "#" :'RODADA',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 100,
            maxWidth: UtilidadeService.isMobile() ? 60 : 100,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'data',
            headerName: 'DATA',
            minWidth: UtilidadeService.isMobile() ? 90 : 180,
            maxWidth: UtilidadeService.isMobile() ? 90 : 180,
            headerClassName: 'super-app-theme--header',
            //valueFormatter: (params) => dayjs(params.value).format('DD/MM/YYYY HH:mm'),
            headerAlign: "center",
            align: "center",
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {dayjs(params.value).format('DD/MM/YYYY HH:mm')}
                         </Box>
                );
            },
        },
        {
            field: 'caminho_Logo',
            headerName: '',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 80,
            maxWidth: UtilidadeService.isMobile() ? 60 : 80,
            sortable: false,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => <img src={franquiaFiltro === params.row.codigo_Franquia_Mandante ? 
                                lstFranquias.find(l => l.codigo === params.row.codigo_Franquia_Visitante)?.descricao === null ? showImagemFranquia 
                                : lstFranquias.find(l => l.codigo === params.row.codigo_Franquia_Visitante)?.descricao 
                                :  lstFranquias.find(l => l.codigo === params.row.codigo_Franquia_Mandante)?.descricao === null ? showImagemFranquia 
                                : lstFranquias.find(l => l.codigo === params.row.codigo_Franquia_Mandante)?.descricao} width={45} height={50} alt="logo" />,
        },
        {
            field: 'nome_Franquia',
            headerName: 'VS FRANQUIA',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 130 : 180,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        {/* <span style={{
                            color: params.row.status_Jogo &&  params.row.empate ? "#E46106"
                            : params.row.status_Jogo && ((franquiaFiltro === params.row.codigo_Franquia_Mandante &&  !params.row.vencedor_Mandante) || (franquiaFiltro === params.row.codigo_Franquia_Visitante &&  !params.row.vencedor_Visitante)) ? "#00e676": "auto"  , fontWeight: "bold"
                                //:  params.row.mandanteVencedor ? "#00e676": "auto", fontWeight: "bold"
                        }}> */}
                            {franquiaFiltro === params.row.codigo_Franquia_Mandante ? lstFranquias.find(l =>  l.codigo === params.row.codigo_Franquia_Visitante)?.label : lstFranquias.find(l =>  l.codigo === params.row.codigo_Franquia_Mandante)?.label}
                        {/* </span> */}
                    </Box>
                );
            },
        },

        {
            field: 'placar_Mandante',
            headerName: '',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 65,
            maxWidth: UtilidadeService.isMobile() ? 60 : 65,
            sortable: false,
            editable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                      {params.value === null || params.value === undefined ? 0 : params.value}
                    </Box>
                );
            },
             
        },
        {
            field: '-',
            headerName: 'PLACAR',
            headerClassName: 'super-app-theme--header',           
            minWidth: UtilidadeService.isMobile() ? 80 : 95,
            maxWidth: UtilidadeService.isMobile() ? 80 : 95,
            sortable: false,
            editable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => " X "
        },
        {
            field: 'placar_Visitante',
            headerName: '',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 60 : 65,
            maxWidth: UtilidadeService.isMobile() ? 60 : 65,
            sortable: false,
            editable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                      {params.value === null || params.value === undefined ? 0 : params.value}
                    </Box>
                );
            },
        },
        {
            field: '*',
            headerName: 'RESULTADO',
            headerClassName: 'super-app-theme--header',           
            minWidth: UtilidadeService.isMobile() ? 90 : 125,
            maxWidth: UtilidadeService.isMobile() ? 90 : 125,
            sortable: false,
            editable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                        <span style={{
                            color: params.row.status_Jogo &&  params.row.empate ? "#E46106"
                            : params.row.status_Jogo && ((franquiaFiltro === params.row.codigo_Franquia_Mandante &&  !params.row.vencedor_Mandante) || (franquiaFiltro === params.row.codigo_Franquia_Visitante &&  !params.row.vencedor_Visitante)) ? "auto": "#00e676"  , fontWeight: "bold"
                                //:  params.row.mandanteVencedor ? "#00e676": "auto", fontWeight: "bold"
                        }}>
                            {params.row.empate ? "Empate"
                            : params.row.status_Jogo && ((franquiaFiltro === params.row.codigo_Franquia_Mandante &&  !params.row.vencedor_Mandante) || (franquiaFiltro === params.row.codigo_Franquia_Visitante &&  !params.row.vencedor_Visitante)) ? "Derrota"
                            : params.row.status_Jogo && ((franquiaFiltro === params.row.codigo_Franquia_Mandante &&  params.row.vencedor_Mandante) || (franquiaFiltro === params.row.codigo_Franquia_Visitante &&  params.row.vencedor_Visitante)) ? "Vitória" : "-"}
                        </span>
                    </Box>
                );
            },
        },
        {
            field: 'codigo_Status_Jogo',
            headerName: 'SITUAÇÃO',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 100 : 165,
            maxWidth: UtilidadeService.isMobile() ? 100 : 165,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                        }}
                    >
                      {params.value === 2 ? <span style={{ color: "#679af9" }}>&nbsp;Em andamento</span> : params.value === 3 ? <span style={{ color: "#EF0BBF" }}>&nbsp; Finalizado &nbsp;</span> : <span style={{ color: "#1FC7E8" }}>&nbsp; Aguardando Início </span>}
                    </Box>
                );
            },
        },

    ];

    return (
        <LayoutBaseDePagina
            titulo={`Calendário Franquia - ${dadosLiga?.nome}`}
            showLogoImg={showImagemLiga}
            barraDeFerramentas={<FerramentasDaListagem
                textoBotaoNovo="Nova"
                mostrarBotaoNovo={false}
                mostrarInputBusca={false}
                aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}
            />}>

            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <Box margin={1} display="flex" component={Paper} variant="outlined"  >
                <Grid container size={{ xs: 12, sm: 12 }} sx={{ width: "100%" }}>
                    <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={2} >
                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1}>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6"> Franquia Versus por Rodada</Typography>
                                <hr />
                            </Grid>
                            <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="initial" spacing={2}>
                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={temporadaFiltro}
                                            label="Temporadas"
                                            onChange={handleSelectedTemporada}
                                        >
                                            <MenuItem value={0}>Selecione</MenuItem>
                                            {
                                                lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }

                                        </Select>
                                    </FormControl >
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Franquias</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={franquiaFiltro}
                                            label="Franquia"
                                            onChange={handleSelectedFranquia}
                                        >
                                            <MenuItem value={0}>Selecione</MenuItem>
                                            {
                                                lstFranquias.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }
                                        </Select>
                                    </FormControl >
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6, md: 3 }} display={"flex"} justifyContent={"center"} alignSelf={"center"}>
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        disableElevation
                                        onClick={() => CarregarCalendarioFranquia(Number(codigoLiga), Number(temporadaFiltro), franquiaFiltro)}
                                        startIcon={<Icon>change_circle</Icon>}
                                    >
                                        Pesquisar
                                    </Button>
                                </Grid>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}>
                                {isLoading && !removeLoading && <Loading />}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}  >
                                {dadosCalendarioRow.length > 0 ? (
                                    <Box sx={{
                                        height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                        '& .super-app-theme--header': {
                                            backgroundColor: theme.palette.common.black,
                                            color: theme.palette.common.white,
                                        },
                                        '& .super-app.negative': {
                                            color: 'red',
                                            fontWeight: 'bold'
                                        },
                                        '& .super-app.positive': {
                                            color: "#00e676",
                                            fontWeight: '600',
                                        },
                                        '& .super-app-theme--cell': {
                                            color: '#00e676',
                                            fontWeight: '600',
                                        },
                                        '& .super-app.nomeRight ': {
                                            justifyContent: "right",
                                        },
                                        '& .super-app.nomeLeft': {
                                            justifyContent: "left",
                                        },
                                        '& .super-app--add': {
                                            backgroundColor: "black",
                                            color: "white",
                                        }
                                    }}>
                                        <DataGrid
                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                            getRowId={(r) => r.codigo}
                                            rows={dadosCalendarioRow}
                                            columns={columnsGeral}
                                            initialState={{
                                                pagination: {
                                                    paginationModel: {
                                                        pageSize: 50,
                                                    },
                                                },
                                            }}
                                            columnVisibilityModel={{
                                                codigo: false,
                                                quantidade_Jogos: false,
                                            }}
                                            disableDensitySelector
                                            disableVirtualization
                                            pageSizeOptions={[50, 100]}
                                            disableRowSelectionOnClick
                                            disableColumnFilter
                                            disableColumnMenu                                            
                                            sx={{
                                                fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                            }}

                                        />
                                    </Box>

                                ) :
                                    <Grid size={{ xs: 12, sm: 12 }} >
                                        <Typography variant="h6">Não possui dados para a temporada selecionada!</Typography>
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </LayoutBaseDePagina>
    )
}


